// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"simple_dropdown_menu_wrapper__1V9hi","menu":"simple_dropdown_menu_menu__cR-vF","menuitem":"simple_dropdown_menu_menuitem__3OP2Z"};